import type { RoleAssumptionState } from '@makemydeal/dr-dash-types';
import { useSelector } from 'react-redux';

/**
 * Hook to select the role assumption state from the Redux store
 * @returns RoleAssumptionState containing role assumption information
 */
export const useRoleAssumptionSelector = (): RoleAssumptionState => {
    const state: RoleAssumptionState = useSelector((state: any) => state.roleAssumption);
    return state;
};
